import { onloadTracking } from './Tracking/checkoutTrackingStep2';
import { CheckoutService } from "./checkoutService";
import ICheckoutflowResponse = CheckoutflowReponse.ICheckoutflowResponse;
import { trackPrefixNameProblem } from '../Tracking/GoogleTracking';
const checkoutService = new CheckoutService();

$(() => {
    checkoutService.showBasket()
        .then(async (response: ICheckoutflowResponse) => {
            let cart = response.cart;        
            onloadTracking(cart);
        })

    if ($("#RegisterErrorOccured").val() == "True") {
        loginSlides($("#registerButton"));
    }

    $(".loginDataSection-trigger").click(function (event) {
        event.preventDefault();
        loginSlides($(this));
    });

    $('#checkoutRegisterForm').on('submit', function (e) {
        const middleName = $(e.target).find("#MiddleName").val();
        const lastName = $(e.target).find("#Surname").val();

        if (middleName && !lastName) {
            trackPrefixNameProblem();
        }
    });


});

function loginSlides(button : JQuery) {
    var getId = button.attr("data-target");

    $("#mm-content-01").find(".link").show();
    if (getId == "#mm-content-02") {
        $("#mm-content-01").next(".min-max-content").removeClass("hideContent").slideUp();
        $("#mm-content-02").next(".min-max-content").removeClass("hideContent").slideDown();
        $("#mm-content-03").next(".min-max-content").removeClass("hideContent").slideUp();
    }
    if (getId == "#mm-content-03") {
        $("#mm-content-01").next(".min-max-content").removeClass("hideContent").slideUp();
        $("#mm-content-02").next(".min-max-content").removeClass("hideContent").slideUp();
        $("#mm-content-03").next(".min-max-content").removeClass("hideContent").slideDown();
    }
}
